module.exports = __webpack_public_path__ + "static/media/cityHarvest.d9e16370.png";